var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surname-search-form-block"},[_c('div',{staticClass:"heading-6"},[_vm._v(_vm._s(_vm.title))]),_c('surname-search-form',{attrs:{"placeholder":"Last name","button-label":"Go"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }